const SvgComponent = props => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M5.83203 12.0835L9.9987 7.91683L14.1654 12.0835" stroke="#9B9DAE" strokeWidth="1.8" />
  </svg>
);

export default SvgComponent;
